import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class BackToTop {
    constructor() {
        this.init();
    }

    init() {
        const backToTopButton = document.getElementById('backToTop');

        this.animStickyElements(backToTopButton);

        backToTopButton.addEventListener('click', () => {
            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: 0,
                    ease: 'power2.inOut'
                }
            });
        });
    }

    animStickyElements(element) {
        const stickyElements = gsap.timeline()
            .to(element, {
                autoAlpha: 1,
                scale: 1,
                startAt: {
                    scale: 0,
                },
                ease: "back.out(1.7)",
            });

        ScrollTrigger.create({
            trigger: "body",
            start: "top+=25% bottom",
            animation: stickyElements,
            toggleActions: "play none none reverse",
            fastScrollEnd: false,
            // markers: true,
        });
    }
}
